export enum NotificationType {
  MESSAGING = "MESSAGING",
  NOTIFICATION = "NOTIFICATION",
}

export enum NOTIFICATION_ID {
  PU1L = "PU1L",
  PU2L = "PU2L",
  PU3L = "PU3L",
  PU4L = "PU4L",
  PU5L = "PU5L",
  PU6L = "PU6L",
  PU7L = "PU7L",
  PU8L = "PU8L",
  PU9L = "PU9L",
  PU10L = "PU10L",
  PU11L = "PU11L",
  PU1H = "PU1H",
  PU2H = "PU2H",
  PU3H = "PU3H",
  PU4H = "PU4H",
  PU5H = "PU5H",
  PU6H = "PU6H",
  PU7H = "PU7H",
  PU8H = "PU8H",
  PU9H = "PU9H",
  PU10H = "PU10H",
  PU11H = "PU11H",
  G3H = "G3H",
  G4L = "G4L",
  G3L = "G3L",
  G6H = "G6H",
  G22H = "G22H",
  G23L = "G23L",
  OB5L = "OB5L",
  OB5H = "OB5H",
  OB8L = "OB8L",
  OB13H = "OB13H",
  OB9L = "OB9L",
  G20H = "G20H",
  G21L = "G21L",
  G9H = "G9H",
  G11L = "G11L",
  G12L = "G12L",
  G14L = "G14L",
  G16L = "G16L",

  G10L = "G10L",
  G18L = "G18L",
}

export type AllowedKeys =
  | "title"
  | "gigTitle"
  | "chefName"
  | "clientName"
  | "depositLink"
  | "acceptLink"
  | "declineLink"
  | "gigDate";

export type NotificationMetaData = {
  key: AllowedKeys;
  value?: string;
}[];
